import { FC } from 'react';
import { useClockStore } from '@/stores/ClockStore';

export const ClockTime: FC = () => {
  const clockTime = useClockStore((state) => state.clockTime);
  return <>{clockTime}</>;
};
